import { Component, Input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-kundengruppe-kundengrp-list-view',
  imports: [],
  templateUrl: './kundengruppe-kundengrp.list-view.html',
  styleUrls: ['./kundengruppe-kundengrp.list-view.css'],
})
export class KundengruppeKundengrpListView implements FieldOkItemComponent<any> {
  @Input() item: any;
}
